import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { renameFolder } from '@widgets/Files/api/renameFolder';
import { handleStatusError } from '@widgets/Files/helpers/handleStatusError';

export const useRenameFolder = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation({
        mutationKey: ['renameFolder'],
        mutationFn: renameFolder,
        onSuccess: (data) => {
            handleStatusError(data, t('useFileUpload.return.swal.manyFiles.button'));
            if (data.status === 'success') {
                queryClient.invalidateQueries({ queryKey: ['files'] });
            }
        },
    });
};
